import { render } from "./HeaderNavigation.vue?vue&type=template&id=c48d2b0a&scoped=true"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=c48d2b0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48d2b0a"]])

export default __exports__